import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import {
  AllowedDomainSettingFragment,
  ReportSettingFieldsFragment,
} from './fragments';
import {
  AnalysisFieldsFragment,
  AnalysisMetaFieldsFragment,
} from '../analysis/fragments';

export const EDIT_REPORT_SETTING = gql`
  mutation reportSettingEdit($input: ReportSettingEditInput!) {
    reportSettingEdit(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...ReportSettingFields
      }
    }
  }
  ${ErrorFragment}
  ${ReportSettingFieldsFragment}
`;

export const EDIT_ALLOWED_DOMAIN_SETTING = gql`
  mutation AllowedDomainSettingEdit($input: AllowedDomainSettingEditInput!) {
    allowedDomainSettingEdit(input: $input) {
      entity {
        ...AllowedDomainSettingFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AllowedDomainSettingFragment}
  ${ErrorFragment}
`;

export const ASSIGN_CUSTOMER_PLAN_MTU_REPORT = gql`
  mutation CustomerSetMTUReport(
    $analysisId: ID!
    $populateBuilder: Boolean = false
  ) {
    customerSetMTUReport(input: { analysisId: $analysisId }) {
      analysis {
        ...AnalysisMetaFields
        ...AnalysisFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${AnalysisFieldsFragment}
  ${ErrorFragment}
`;
